import axios from "axios";
import { authenticatedApiConfig, generateURL } from "./BaseApiService";
export class JobManagementService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async retryJob(jobId, fromArchive) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/admin/jobs/:id/retry", { id: jobId }), {}, await authenticatedApiConfig(this.authenticationProvider, fromArchive ? { fromArchive: "true" } : undefined));
        return response.data;
    }
    async cancelJob(jobId) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/admin/jobs/:id/cancel", { id: jobId }), {}, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async resumeJob(jobId) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/admin/jobs/:id/resume", { id: jobId }), {}, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getQueues() {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/queues"), await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getQueueStats(queueName) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/queues/:name/stats", { name: queueName }), await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getQueueJobs(queueName, params) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/queues/:name/jobs", { name: queueName }), await authenticatedApiConfig(this.authenticationProvider, params));
        return response.data;
    }
    async deleteQueue(queueName, confirm) {
        const response = await axios.delete(generateURL(this.environment.API_BASE_URL, "/admin/queues/:name", { name: queueName }), await authenticatedApiConfig(this.authenticationProvider, { confirm: confirm.toString() }));
        return response.data;
    }
    async purgeQueue(queueName) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/admin/queues/:name/purge", { name: queueName }), {}, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getSchedules() {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/schedules"), await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
}
